import { render, staticRenderFns } from "./AddNewDetailModal.vue?vue&type=template&id=1e0ea18b&scoped=true&"
import script from "./AddNewDetailModal.vue?vue&type=script&lang=js&"
export * from "./AddNewDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./AddNewDetailModal.vue?vue&type=style&index=0&id=1e0ea18b&scoped=true&lang=css&"
import style1 from "./AddNewDetailModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0ea18b",
  null
  
)

export default component.exports